import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faEye } from '@fortawesome/pro-light-svg-icons';

export type ProLightEyeProps = IconComponentProps;

export const ProLightEye = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightEyeProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faEye}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faEye}
    />
  );
};

ProLightEye.displayName = 'ProLightEye';
